import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Path } from '../Routing';

const Container = styled.div`
  text-align: center;
  margin: 0 2vw;
  flex: 1;
  margin: 32px 0 80px;
`;

const Title = styled.h1`
  font-size: 1.125rem;
  font-weight: bold;
`;

const Text = styled.p`
  font-size: 0.875rem;
  text-align: center;
  padding: 20px 10px;
`;

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Title>{t('notFound.title')}</Title>
      <Text>{t('notFound.text')}</Text>
      <Link to={Path.Home}>{t('notFound.clickHere')}</Link>
      {t('notFound.returnHome')}
    </Container>
  );
};

export default NotFound;
